exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n * The following styles are auto-applied to elements with\r\n * transition=\"modal\" when their visibility is toggled\r\n * by Vue.js.\r\n *\r\n * You can easily play with the modal transition by editing\r\n * these styles.\r\n */\n.modal-enter[data-v-701ac82d] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-701ac82d] {\n  opacity: 0;\n}\n.modal-enter .modal-container[data-v-701ac82d],\n.modal-leave-active .modal-container[data-v-701ac82d] {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n", ""]);

// exports
